'use client';

// ── Profit Split — "division" example ────────────────────────────────────────
// Figma: Moldura 12071:60042 (desktop, 792×220) and 12471:11415 (mobile, 366×336).
// A 70–100% slider at ~90% and the bar showing how a payout is divided between
// the trader and IQ Capital. Static example reproduced per frame: Figma draws
// the "You" segment at 82.5% of the bar on desktop and 90% on mobile, and puts
// the "IQ" label inside the bar on desktop / below it on mobile.
// Every number is an illustrative example; sizes are Figma px / 8.

import { FigureFrame } from '../primitives';

const ASSETS = '/general-rules-v3/profit-split';

const T = 'mb-0 text-[2rem] leading-[3rem]';

export default function ProfitSplit() {
  return (
    // `main` sets text-wrap: balance globally; Figma wraps greedily.
    <FigureFrame data-ui="figure.profitSplit" className="gap-[2.5rem] font-geist [text-wrap:wrap]">
      {/* Topo: label + 70% — 100% range */}
      <div
        data-ui="figure.profitSplit.top"
        className="flex w-full flex-col gap-[1.5rem] lg:flex-row lg:items-start lg:justify-between lg:gap-0"
      >
        <p className={`${T} whitespace-nowrap font-medium uppercase text-black/40`}>Your share of the profit</p>
        <div className="flex w-full items-start justify-between lg:w-auto lg:gap-[1rem]">
          <p className={`${T} whitespace-nowrap text-black/40`}>70%</p>
          <p className={`${T} hidden whitespace-nowrap text-black/[0.24] lg:block`}>—</p>
          <p className={`${T} whitespace-nowrap text-black/40`}>100%</p>
        </div>
      </div>

      {/* Trilho do slider: track 694/744 (93.28%), fill 462.96/744 (62.23%), knob centred on the fill end */}
      <div data-ui="figure.profitSplit.track" className="relative h-[2rem] w-full">
        <div className="absolute left-0 top-[0.75rem] h-[0.5rem] w-[93.28%] rounded-[0.25rem] bg-black/10" />
        <div
          data-ui="figure.profitSplit.track-fill"
          className="absolute left-0 top-[0.75rem] h-[0.5rem] w-[62.23%] rounded-[0.25rem] bg-[#228e71]"
        />
        <img
          data-ui="figure.profitSplit.knob"
          alt=""
          src={`${ASSETS}/slider-knob.svg`}
          className="absolute left-[calc(62.23%_-_1rem)] top-0 h-[2rem] w-[2rem] max-w-none"
        />
      </div>

      {/* Divisão: You ~90% / IQ ~10% */}
      <div data-ui="figure.profitSplit.bar" className="relative h-[10rem] w-full lg:h-[6rem]">
        <div className="absolute left-0 top-0 h-[6rem] w-full overflow-hidden rounded-[0.25rem] bg-[#001b14]">
          <div
            data-ui="figure.profitSplit.bar-you"
            className="absolute left-0 top-0 h-[6rem] w-[90.07%] rounded-[0.25rem] bg-[#228e71] lg:w-[82.53%]"
          >
            <p className={`${T} absolute left-[1.5rem] top-[1.5rem] whitespace-nowrap font-medium text-white lg:left-[1.25rem]`}>
              You ~90%
            </p>
          </div>
          <p
            className={`${T} absolute left-[calc(82.53%_+_1.375rem)] top-[1.25rem] hidden whitespace-nowrap font-medium text-white lg:block`}
          >
            IQ ~10%
          </p>
        </div>
        <p className={`${T} absolute right-[0.2rem] top-[7rem] whitespace-nowrap font-medium text-[#1a1a1a] lg:hidden`}>
          IQ ~10%
        </p>
      </div>

      <p data-ui="figure.profitSplit.note" className={`${T} text-black/[0.64]`}>
        Move the slider to see how a payout is divided. Your actual split depends on your account type.
      </p>
    </FigureFrame>
  );
}
